// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `input[type="range"] {
    --range-progress: 0;
    
    position: relative;
    background:#ccc;
    width: 100%;
    height: 2px;
    border-radius: 2px;
    cursor: pointer;
    margin-bottom: 14px;
  }
  
  /* Input range - firefox */
  input[type="range"]::-moz-range-track {
    position: relative;
    background:#ccc;
    width: 100%;
    height: 2px;
    border-radius: 2px;
    cursor: pointer;
  }
  
  /* played progress length - Chrome & safari*/
  input[type="range"]::before {
    content: '';
    height: 2px;
    background: rgb(19, 79, 207);
    width: var(--range-progress);
    border-bottom-left-radius: 2px;
    border-top-left-radius: 2px;
    position: absolute;
    top: 0;
    left: 0;
    transition: all ease-in-out 0.5s;
  }
  
  /* played progress length - firefox */
  input[type="range"]::-moz-range-progress {
    background: rgb(19, 79, 207);
    border-bottom-left-radius: 2px;
    border-top-left-radius: 2px;
    height: 2px;
  }
  
  /* slider thumb - chrome and safari */
  input[type="range"]::-webkit-slider-thumb {
    -webkit-appearance: none;
    height: 8px;
    width: 8px;
    border-radius: 50%;
    border: none;
    background-color: rgb(19, 79, 207);
    cursor: pointer;
    position: relative;
  }
  
  /* dragging thumb - chrome and safari */
  input[type="range"]:active::-webkit-slider-thumb {
    transform: scale(1.2);
  }
  
  /* slider thumb - firefox */
  input[type="range"]::-moz-range-thumb {
    height: 8px;
    width: 8px;
    border-radius: 50%;
    background: rgb(19, 79, 207);
    cursor: pointer;
    border: transparent;
    position: relative;
  }
  /* dragging thumb - firefox */
  input[type="range"]:active::-moz-range-thumb {
    transform: scale(1.2);
  }`, "",{"version":3,"sources":["webpack://./src/components/AudioPlayer/AudioPlayer.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;;IAEnB,kBAAkB;IAClB,eAAe;IACf,WAAW;IACX,WAAW;IACX,kBAAkB;IAClB,eAAe;IACf,mBAAmB;EACrB;;EAEA,0BAA0B;EAC1B;IACE,kBAAkB;IAClB,eAAe;IACf,WAAW;IACX,WAAW;IACX,kBAAkB;IAClB,eAAe;EACjB;;EAEA,4CAA4C;EAC5C;IACE,WAAW;IACX,WAAW;IACX,4BAA4B;IAC5B,4BAA4B;IAC5B,8BAA8B;IAC9B,2BAA2B;IAC3B,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,gCAAgC;EAClC;;EAEA,qCAAqC;EACrC;IACE,4BAA4B;IAC5B,8BAA8B;IAC9B,2BAA2B;IAC3B,WAAW;EACb;;EAEA,qCAAqC;EACrC;IACE,wBAAwB;IACxB,WAAW;IACX,UAAU;IACV,kBAAkB;IAClB,YAAY;IACZ,kCAAkC;IAClC,eAAe;IACf,kBAAkB;EACpB;;EAEA,uCAAuC;EACvC;IACE,qBAAqB;EACvB;;EAEA,2BAA2B;EAC3B;IACE,WAAW;IACX,UAAU;IACV,kBAAkB;IAClB,4BAA4B;IAC5B,eAAe;IACf,mBAAmB;IACnB,kBAAkB;EACpB;EACA,6BAA6B;EAC7B;IACE,qBAAqB;EACvB","sourcesContent":["input[type=\"range\"] {\r\n    --range-progress: 0;\r\n    \r\n    position: relative;\r\n    background:#ccc;\r\n    width: 100%;\r\n    height: 2px;\r\n    border-radius: 2px;\r\n    cursor: pointer;\r\n    margin-bottom: 14px;\r\n  }\r\n  \r\n  /* Input range - firefox */\r\n  input[type=\"range\"]::-moz-range-track {\r\n    position: relative;\r\n    background:#ccc;\r\n    width: 100%;\r\n    height: 2px;\r\n    border-radius: 2px;\r\n    cursor: pointer;\r\n  }\r\n  \r\n  /* played progress length - Chrome & safari*/\r\n  input[type=\"range\"]::before {\r\n    content: '';\r\n    height: 2px;\r\n    background: rgb(19, 79, 207);\r\n    width: var(--range-progress);\r\n    border-bottom-left-radius: 2px;\r\n    border-top-left-radius: 2px;\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    transition: all ease-in-out 0.5s;\r\n  }\r\n  \r\n  /* played progress length - firefox */\r\n  input[type=\"range\"]::-moz-range-progress {\r\n    background: rgb(19, 79, 207);\r\n    border-bottom-left-radius: 2px;\r\n    border-top-left-radius: 2px;\r\n    height: 2px;\r\n  }\r\n  \r\n  /* slider thumb - chrome and safari */\r\n  input[type=\"range\"]::-webkit-slider-thumb {\r\n    -webkit-appearance: none;\r\n    height: 8px;\r\n    width: 8px;\r\n    border-radius: 50%;\r\n    border: none;\r\n    background-color: rgb(19, 79, 207);\r\n    cursor: pointer;\r\n    position: relative;\r\n  }\r\n  \r\n  /* dragging thumb - chrome and safari */\r\n  input[type=\"range\"]:active::-webkit-slider-thumb {\r\n    transform: scale(1.2);\r\n  }\r\n  \r\n  /* slider thumb - firefox */\r\n  input[type=\"range\"]::-moz-range-thumb {\r\n    height: 8px;\r\n    width: 8px;\r\n    border-radius: 50%;\r\n    background: rgb(19, 79, 207);\r\n    cursor: pointer;\r\n    border: transparent;\r\n    position: relative;\r\n  }\r\n  /* dragging thumb - firefox */\r\n  input[type=\"range\"]:active::-moz-range-thumb {\r\n    transform: scale(1.2);\r\n  }"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
